const getMainOptions = () => {
  const mainOptionMixers = document.querySelector(".cld-mo-mixer");
  const mainOptionMixerAmp = document.querySelector(".cld-mo-mixer-amps");
  const mainOptionPowerAmp = document.querySelector(".cld-mo-power-amps");

  const mixerWrapper = document.querySelector("#mixers-wrapper");
  const mixerAmpWrapper = document.querySelector("#mixer-amplifier-wrapper");
  const powerAmpWrapper = document.querySelector("#power-amplifier-wrapper");

  return {
    mainOptionPowerAmp,
    mainOptionMixerAmp,
    mainOptionMixers,
    mixerWrapper,
    mixerAmpWrapper,
    powerAmpWrapper,
  };
};

const getWallPanels = () => {
  return document.querySelectorAll(".cld-result");
};

const compatibleItems = {
  //=================== MIXERS ===================//
  //==============================================//

  dcm1__dcm1e: [
    "cld-cdr-1",
    "cld-cdr-1f",
    "cld-be-1",
    "cld-le-1",
    "cld-me-1",
    "cld-xlr-m1",
    "cld-xlr-f1",
  ],
  z4__z8: [
    "cld-rl-1",
    "cld-rl-1x8",
    "cld-rsl-6",
    "cld-rsl-6x4",
    "cld-l-1",
    "cld-lm-2",
    "cld-m-1",
    "cld-xlr-m1",
    "cld-xlr-f1",
    "cld-bt-1",
  ],
  cx163: ["cld-rl-1", "cld-rl-1x8", "cld-xlr-m1", "cld-xlr-f1"],

  cx261__cx263__cx462: [
    "cld-rl-1",
    "cld-rl-1x8",
    "cld-rsl-6",
    "cld-rsl-6x4",
    "cld-xlr-m1",
    "cld-xlr-f1",
  ],

  //=================== POWER AMPLIFIERS ===================//
  //========================================================//

  cv2500__cv4250__cv8125: [
    "cld-rl-1",
    "cld-rl-1x8",
    "cld-xlr-m1",
    "cld-xlr-f1",
  ],

  //=================== MIXER AMPLIFIERS ===================//
  //========================================================//

  ma60: ["cld-rl-1", "cld-rl-1x8", "cld-rsl-4", "cld-xlr-m1", "cld-xlr-f1"],
  mpa120mk2__mpa240mk2: [
    "cld-rl-1",
    "cld-rsl-6",
    "cld-l-1",
    "cld-lm-2",
    "cld-m-1",
    "cld-xlr-m1",
    "cld-xlr-f1",
    "cld-bt-1",
  ],
  "24-120__24-240": [
    "cld-rl-1",
    "cld-rl-1x8",
    "cld-rsl-4",
    "cld-rsl-6",
    "cld-rsl-6x4",
    "cld-l-1",
    "cld-lm-2",
    "cld-m-1",
    "cld-xlr-m1",
    "cld-xlr-f1",
  ],
  "46-80__46-80t": [
    "cld-rl-1",
    "cld-rl-1x8",
    "cld-rsl-6",
    "cld-rsl-6x4",
    "cld-l-1",
    "cld-lm-2",
    "cld-m-1",
    "cld-xlr-m1",
    "cld-xlr-f1",
    "cld-bt-1",
  ],
  "46-120mk2_46-240mk2": [
    "cld-rl-1",
    "cld-rl-1x8",
    "cld-rsl-6",
    "cld-rsl-6x4",
    "cld-lm-2",
    "cld-xlr-m1",
    "cld-xlr-f1",
    "cld-bt-1",
  ],

  cxaAmplifiers: ["cld-cdr-3"],

  clearActive() {
    getWallPanels().forEach((panel) => {
      panel.classList.remove("active");
    });
  },

  applyToDcm1__Dcm1e() {
    getWallPanels().forEach((panel) => {
      this.dcm1__dcm1e.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToZ4__Z8() {
    getWallPanels().forEach((panel) => {
      this.z4__z8.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToCX163() {
    getWallPanels().forEach((panel) => {
      this.cx163.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToCX261__CX263__CX462() {
    getWallPanels().forEach((panel) => {
      this.cx261__cx263__cx462.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToCV2500__CV4250__CV8125() {
    getWallPanels().forEach((panel) => {
      this.cv2500__cv4250__cv8125.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToMA60() {
    getWallPanels().forEach((panel) => {
      this.ma60.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToMPA120__MPA240() {
    getWallPanels().forEach((panel) => {
      this.mpa120mk2__mpa240mk2.forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyTo24_120__24_240() {
    getWallPanels().forEach((panel) => {
      this["24-120__24-240"].forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyTo46_80__46_80T() {
    getWallPanels().forEach((panel) => {
      this["46-80__46-80t"].forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyTo46_120MK2() {
    getWallPanels().forEach((panel) => {
      this["46-120mk2_46-240mk2"].forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },

  applyToCXA_Amps() {
    getWallPanels().forEach((panel) => {
      this["cxaAmplifiers"].forEach((panelOption) => {
        if (panel.classList.contains(panelOption)) {
          panel.classList.add("active");
        }
      });
    });
  },
};

//Function to clear the results when a new product or category is selected.
const clearMainOptionsActive = () => {
  const { mainOptionPowerAmp, mainOptionMixerAmp, mainOptionMixers } =
    getMainOptions();

  const { mixerWrapper, mixerAmpWrapper, powerAmpWrapper } = getMainOptions();

  [
    mixerWrapper,
    mixerAmpWrapper,
    powerAmpWrapper,
    mainOptionPowerAmp,
    mainOptionMixerAmp,
    mainOptionMixers,
  ].forEach((wrapper) => {
    wrapper.classList.remove("active");
  });
};

// Function to show and hide each of the categories (mixer, mixer amps and power amps)
const showAndHideSubCategories = () => {
  const { mainOptionPowerAmp, mainOptionMixerAmp, mainOptionMixers } =
    getMainOptions();

  const { mixerWrapper, mixerAmpWrapper, powerAmpWrapper } = getMainOptions();

  mainOptionMixers.addEventListener("click", () => {
    clearMainOptionsActive();
    compatibleItems.clearActive();
    mixerWrapper.classList.add("active");
    mainOptionMixers.classList.add("active");
  });

  mainOptionMixerAmp.addEventListener("click", () => {
    clearMainOptionsActive();
    compatibleItems.clearActive();
    mixerAmpWrapper.classList.add("active");
    mainOptionMixerAmp.classList.add("active");
  });

  mainOptionPowerAmp.addEventListener("click", () => {
    clearMainOptionsActive();
    compatibleItems.clearActive();
    powerAmpWrapper.classList.add("active");
    mainOptionPowerAmp.classList.add("active");
  });
};
showAndHideSubCategories();

const getCategoryProducts = () => {
  const mixers = document.querySelectorAll(".cld-mixer");
  const mixerAmps = document.querySelectorAll(".cld-mixamp");
  const powerAmps = document.querySelectorAll(".cld-powamp");

  return { mixers, mixerAmps, powerAmps };
};

const PRODUCTS = getCategoryProducts();

const clearActiveFromCategoryProducts = () => {
  [...PRODUCTS.powerAmps, ...PRODUCTS.mixerAmps, ...PRODUCTS.mixers].forEach(
    (product) => {
      product.classList.remove("active");
    },
  );
};

/**
 * The select functions below are responsible for adding event listeners to each mixer product.
 * When a product is clicked, it determines which product was clicked based on its classList.
 * It then clears any active classes from the wall panels and applies the appropriate active classes based on the clicked product.
 */
function selectMixer() {
  PRODUCTS.mixers.forEach((mixer) => {
    mixer.addEventListener("click", (e) => {
      switch (
        true // Switch statement to determine which mixer was clicked
      ) {
        case e.target.classList.contains("cld-dcm1") ||
          e.target.classList.contains("cld-dcm1e"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active"); // Apply active class to the clicked product to apply style
          compatibleItems.clearActive(); // Clear any active classes from the wall panels
          compatibleItems.applyToDcm1__Dcm1e();
          break;

        case e.target.classList.contains("cld-z4") ||
          e.target.classList.contains("cld-z8"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyToZ4__Z8();
          break;

        case e.target.classList.contains("cld-cx163"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyToCX163();
          break;

        case e.target.classList.contains("cld-cx261") ||
          e.target.classList.contains("cld-cx263") ||
          e.target.classList.contains("cld-cx462"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyToCX261__CX263__CX462();
          break;
      }
    });
  });
}
function selectMixerAmp() {
  PRODUCTS.mixerAmps.forEach((mixerAmp) => {
    mixerAmp.addEventListener("click", (e) => {
      switch (
        true // Switch statement to determine which mixer was clicked
      ) {
        case e.target.classList.contains("cld-ma60"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyToMA60();
          break;

        case e.target.classList.contains("cld-mpa120mk2") ||
          e.target.classList.contains("cld-mpa240mk2"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyToMPA120__MPA240();
          break;

        case e.target.classList.contains("cld-24-120") ||
          e.target.classList.contains("cld-24-240"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyTo24_120__24_240();
          break;

        case e.target.classList.contains("cld-46-80") ||
          e.target.classList.contains("cld-46-80t"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyTo46_80__46_80T();
          break;

        case e.target.classList.contains("cld-46-120mk2") || e.target.classList.contains("cld-46-240mk2"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyTo46_120MK2();
          break;

          case e.target.classList.contains("cld-46-240mk2"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyTo46_120MK2();
          break;

        case e.target.classList.contains("cld-cxa-amplifier"):
          clearActiveFromCategoryProducts();
          e.target.classList.add("active");
          compatibleItems.clearActive();
          compatibleItems.applyToCXA_Amps();
          break;
      }
    });
  });
}
function selectPowerAmp() {
  PRODUCTS.powerAmps.forEach((powerAmp) => {
    powerAmp.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("cld-cv2500") ||
        e.target.classList.contains("cld-cv4250") ||
        e.target.classList.contains("cld-cv8125")
      ) {
        clearActiveFromCategoryProducts();
        e.target.classList.add("active");
        compatibleItems.clearActive();
        compatibleItems.applyToCV2500__CV4250__CV8125();
      }
    });
  });
}

selectMixer();
selectMixerAmp();
selectPowerAmp();

const getColors = () => {
  const getDropDowns = document.querySelectorAll(".color-dropdown");
  const getColorOptionBlack = document.querySelectorAll(".color-black");
  const getColorOptionWhite = document.querySelectorAll(".color-white");

  const idInput = [
    "cdr-1-id",
    "cdr-1f-id",
    "be-1-id",
    "le-1-id",
    "me-1-id",
    "rl-1-id",
    "rl-1x8-id",
    "rsl-4-id",
    "rsl-6-id",
    "rsl-6x4-id",
    "l-1-id",
    "m-1-id",
    "xlr-m1-id",
    "xlr-f1-id",
    "lm-2-id",
    "bt-1-id",
    "cdr-3-id",
  ];

  const getProductID = idInput.reduce((acc, item) => {
    acc[item] = document.querySelector(`.${item}`);
    return acc;
  }, {});

  return {
    getDropDowns,
    getColorOptionBlack,
    getColorOptionWhite,
    getProductID,
  };
};

const selectColourVariant = () => {
  const dropDownLists = getColors().getDropDowns;

  dropDownLists.forEach((dropdown) => {
    dropdown.addEventListener("change", (e) => {
      switch (true) {
        case e.target.classList.contains("cdr-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["cdr-1-id"].value = "42915369320698";
          } else {
            getColors().getProductID["cdr-1-id"].value = "42915369255162";
          }
          break;

        case e.target.classList.contains("cdr-1f-color"):
          if (e.target.value === "black") {
            getColors().getProductID["cdr-1f-id"].value = "44774838698234";
          } else if (e.target.value === "white") {
            getColors().getProductID["cdr-1f-id"].value = "44774838665466";
          } else {
            getColors().getProductID["cdr-1f-id"].value = "44774838731002";
          }
          break;

        case e.target.classList.contains("be-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["be-1-id"].value = "45429878620410";
          } else {
            getColors().getProductID["be-1-id"].value = "45429878587642";
          }
          break;

        case e.target.classList.contains("le-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["le-1-id"].value = "45429900935418";
          } else {
            getColors().getProductID["le-1-id"].value = "45429900902650";
          }
          break;

        case e.target.classList.contains("me-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["me-1-id"].value = "42915344613626";
          } else {
            getColors().getProductID["me-1-id"].value = "42915344580858";
          }
          break;

        case e.target.classList.contains("rl-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["rl-1-id"].value = "13272431788085";
          } else {
            getColors().getProductID["rl-1-id"].value = "13272490999861";
          }
          break;

        case e.target.classList.contains("rl-1x8-color"):
          if (e.target.value === "black") {
            getColors().getProductID["rl-1x8-id"].value = "45429931933946";
          } else {
            getColors().getProductID["rl-1x8-id"].value = "45429931901178";
          }
          break;

        case e.target.classList.contains("rsl-4-color"):
          if (e.target.value === "black") {
            getColors().getProductID["rsl-4-id"].value = "42918816448762";
          } else {
            getColors().getProductID["rsl-4-id"].value = "42918816481530";
          }
          break;

        case e.target.classList.contains("rsl-6-color"):
          if (e.target.value === "black") {
            getColors().getProductID["rsl-6-id"].value = "45429987836154";
          } else {
            getColors().getProductID["rsl-6-id"].value = "45429987803386";
          }
          break;

        case e.target.classList.contains("rsl-6x4-color"):
          if (e.target.value === "black") {
            getColors().getProductID["rsl-6x4-id"].value = "44617822437626";
          } else {
            getColors().getProductID["rsl-6x4-id"].value = "44617822470394";
          }
          break;

        case e.target.classList.contains("l-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["l-1-id"].value = "45430070411514";
          } else {
            getColors().getProductID["l-1-id"].value = "45430070378746";
          }
          break;

        case e.target.classList.contains("m-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["m-1-id"].value = "45430099083514";
          } else {
            getColors().getProductID["m-1-id"].value = "45430099050746";
          }
          break;

        case e.target.classList.contains("xlr-m1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["xlr-m1-id"].value = "45430135062778";
          } else {
            getColors().getProductID["xlr-m1-id"].value = "45430135030010";
          }
          break;

        case e.target.classList.contains("xlr-f1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["xlr-f1-id"].value = "45430154002682";
          } else {
            getColors().getProductID["xlr-f1-id"].value = "45430153969914";
          }
          break;

        case e.target.classList.contains("lm-2-color"):
          if (e.target.value === "black") {
            getColors().getProductID["lm-2-id"].value = "45430154002682";
          } else {
            getColors().getProductID["lm-2-id"].value = "40181413675192";
          }
          break;

        case e.target.classList.contains("bt-1-color"):
          if (e.target.value === "black") {
            getColors().getProductID["bt-1-id"].value = "13272600444981";
          } else {
            getColors().getProductID["bt-1-id"].value = "13272600412213";
          }
          break;

        case e.target.classList.contains("cdr-3-color"):
          if (e.target.value === "black") {
            getColors().getProductID["cdr-3-id"].value = "45520275210490";
          } else {
            getColors().getProductID["cdr-3-id"].value = "45520275177722";
          }
          break;
      }
    });
  });
};
selectColourVariant();

const scrollIntoView = () => {
  const targetView = document.querySelector("#hr-scroll");
  const subCategory = document.querySelectorAll(".cld-subcat");

  subCategory.forEach((item) => {
    item.addEventListener("click", () => {
      if (window.innerWidth < 1025) {
        targetView.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });
};
scrollIntoView();
